import { Gift, Trophy } from "lucide-react";
import { siteConfig } from "../lib/siteConfig";
export default function AchievementCard({ achievement, busy, onClaim }) {
  const complete = Boolean(achievement?.complete);
  const claimed = Boolean(achievement?.claimed);
  const claimable = Boolean(achievement?.claimable) && !claimed;
  return (
    <article className="rounded-2xl border border-slate-200 bg-slate-50 p-4 sm:p-5">
      <div className="flex items-start justify-between gap-4">
        <div className="flex min-w-0 items-start gap-4">
          <div className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-[#2f78b7]/10 text-[#2f78b7]">
            <AchievementIcon name={achievement?.icon} />
          </div>
          <div className="min-w-0">
            <h3 className="truncate text-lg font-black text-black">{achievement?.title || "Achievement"}</h3>
            <p className="mt-1 text-sm font-semibold uppercase tracking-wide text-slate-700">{siteConfig.name}</p>
          </div>
        </div>
        <span className="shrink-0 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-sm font-black text-emerald-600">
          {achievement?.reward_label || "$0.00 Freeplay"}
        </span>
      </div>

      {achievement?.description && (
        <p className="mt-4 text-sm text-slate-600">{achievement.description}</p>
      )}

      <div className="mt-5 flex items-center justify-between gap-3">
        <div className="text-xs font-black uppercase tracking-[0.22em] text-slate-500">{achievement?.goal_label || "Goal"}</div>
        <div className="text-sm font-black text-black">
          {formatAchievementProgress(achievement)}
        </div>
      </div>
      <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-slate-200">
        <div
          className="h-full rounded-full bg-[#2f78b7] transition-all"
          style={{ width: `${Math.max(0, Math.min(100, Number(achievement?.progress_percent || 0)))}%` }}
        />
      </div>

      {achievement?.repeat_every_target && (
        <p className="mt-3 text-sm text-slate-600">
          {achievement.reward_label} for every {moneyFromDollars(achievement.target_value)} deposited.
          {achievement.available_claims > 0 ? ` ${achievement.available_claims} reward${achievement.available_claims === 1 ? "" : "s"} ready to claim.` : " Keep depositing toward your next reward."}
        </p>
      )}
      <button
        type="button"
        onClick={onClaim}
        disabled={!claimable || busy}
        className="mt-5 w-full rounded-full bg-[#2f78b7] px-5 py-3 text-sm font-black text-white transition hover:bg-[#256194] disabled:bg-slate-300 disabled:text-slate-600"
      >
        {busy ? "Claiming..." : claimed ? "Claimed" : complete ? "Claim Freeplay" : achievement?.repeat_every_target ? "Next deposit reward" : "Keep playing"}
      </button>
    </article>
  );
}

function AchievementIcon({ name }) {
  const key = String(name || "").toLowerCase();
  if (key.includes("gift")) return <Gift className="h-6 w-6" />;
  return <Trophy className="h-6 w-6" />;
}

function formatAchievementProgress(achievement) {
  const goal = achievement?.goal || "";
  const current = Number(achievement?.progress_value || 0);
  const target = Number(achievement?.next_target_value ?? achievement?.target_value ?? 0);
  if (goal.includes("total")) {
    return `${moneyFromDollars(current)} / ${moneyFromDollars(target)}`;
  }
  return `${prettyCount(current)} / ${prettyCount(target)}`;
}

function prettyCount(value) {
  const number = Number(value || 0);
  return Number.isInteger(number) ? String(number) : number.toFixed(2);
}


function moneyFromDollars(value) { return `$${Number(value || 0).toFixed(2)}`; }
